import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';

/**
 * This service could be used for HTTP requests that should not pass through the interceptor chain,
 * e.g. for requests that doesn't require an authentication.
 * See https://github.com/angular/angular/issues/20203#issuecomment-368680437
 */
@Injectable({
  providedIn: 'root',
})
export class HttpIgnoringInterceptorsService extends HttpClient {
  constructor(handler: HttpBackend) {
    // HttpBackend dispatches requests directly to the backend, without going through the interceptor chain.
    super(handler);
  }
}
